/**
 * Cart Address Data Management
 * Handles address data maps and lookups
 */

(function() {
  'use strict';

  window.CartAddressData = {
    streetCodeMap: new Map(),
    cityCodeMap: new Map(),
    cityStreetsMap: new Map(),
    addresses: [],

    /**
     * Initialize data maps from addresses array
     */
    init(addresses) {
      this.addresses = Array.isArray(addresses) ? addresses : [];
      this.streetCodeMap.clear();
      this.cityCodeMap.clear();
      this.cityStreetsMap.clear();

      this.addresses.forEach(addr => {
        // Street code map
        if (addr.street_name && addr.street_code) {
          this.streetCodeMap.set(addr.street_name, addr.street_code);
        }

        // City code map
        if (addr.city_name && addr.city_code) {
          this.cityCodeMap.set(addr.city_name, addr.city_code);
        }

        // Group streets by city
        if (addr.city_name && addr.street_name) {
          if (!this.cityStreetsMap.has(addr.city_name)) {
            this.cityStreetsMap.set(addr.city_name, []);
          }
          const streets = this.cityStreetsMap.get(addr.city_name);
          if (!streets.includes(addr.street_name)) {
            streets.push(addr.street_name);
          }
        }
      });
    },

    /**
     * Get street code for a street name
     */
    getStreetCode(streetName) {
      return this.streetCodeMap.get(streetName);
    },

    /**
     * Get city code for a city name
     */
    getCityCode(cityName) {
      return this.cityCodeMap.get(cityName);
    },

    /**
     * Get all streets for a city
     */
    getStreetsForCity(cityName) {
      return this.cityStreetsMap.get(cityName) || [];
    },

    /**
     * Get all cities
     */
    getCities() {
      return Array.from(this.cityStreetsMap.keys());
    },

    /**
     * Get all streets (across all cities)
     */
    getAllStreets() {
      return [...new Set(this.addresses.map(a => a.street_name).filter(Boolean))];
    },

    /**
     * Find address entry by city and street
     */
    findAddress(cityName, streetName) {
      return this.addresses.find(a => 
        a.city_name === cityName && a.street_name === streetName
      );
    }
  };
})();

